<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto"></v-col>
    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>آرشیو سفارش‌ها</h6>
      </template>

      <br />
      <div>
        <b-tabs pills card content-class="mr-3">
          <b-tab
            :title="'همه اقلام سفارش‌ها' + ' (' + items.length + ')'"
            active
            @click="currentPage = 1"
          >
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <vue-excel-xlsx
                v-if="items.length > 0"
                style="float: left"
                class="mb-3 btn-dark rounded p-2"
                :data="items"
                :columns="
                  fields
                    .map((y) => {
                      return {
                        label: y.label,
                        field: y.key,
                      };
                    })
                    .filter((x) => x.field != 'index')
                    .filter((x) => x.field != 'operation')
                "
                :file-name="
                  'سفارشات_' +
                  moment(new Date()).format('jYYYY-jMM-jDD_HH_mm_ss')
                "
                :sheet-name="'سفارشات'"
                >خروجی اکسل</vue-excel-xlsx
              >
              <template v-slot:header>
                <h6>
                  <b-input-group size="md">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="جستجو"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                        variant="danger"
                        >حذف</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </h6>
              </template>
              <b-table
                responsive
                show-empty
                :items="items"
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
                @filtered="currentPage = 1"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>

                <template v-slot:cell(progress)="data">
                  <b-progress variant="success">
                    <b-progress-bar
                      :value="data.item.progress"
                      :striped="striped"
                      animated
                      >{{ data.item.progress }} %</b-progress-bar
                    >
                  </b-progress>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="btn btn-primary color mr-1 mt-1"
                      :href="'/factory/order/' + data.item.orderId"
                      target="_blank"
                      role="button"
                      >جزییات سفارش</a
                    >
                    <b-btn
                      variant="success"
                      class="mr-1 mt-1"
                      @click="showModalFollow(data.item)"
                      >ویرایش</b-btn
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>

              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
            </b-card>
          </b-tab>
          <b-tab
            v-for="status in statusOptions"
            :key="status.value"
            :title="
              status.text +
              ' (' +
              items.filter((x) => x.status == status.value).length +
              ')'
            "
            @click="currentPage = 1"
          >
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <template v-slot:header>
                <h6>
                  <b-input-group size="md">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="جستجو"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                        variant="danger"
                        >حذف</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </h6>
              </template>
              <b-table
                responsive
                show-empty
                :items="items.filter((x) => x.status == status.value)"
                :fields="fields"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
                @filtered="currentPage = 1"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>

                <template v-slot:cell(progress)="data">
                  <b-progress variant="success">
                    <b-progress-bar
                      :value="data.item.progress"
                      :striped="striped"
                      animated
                      >{{ data.item.progress }} %</b-progress-bar
                    >
                  </b-progress>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      class="btn btn-primary color mr-1 mt-1"
                      :href="'/factory/order/' + data.item.orderId"
                      target="_blank"
                      role="button"
                      >جزییات سفارش</a
                    >
                    <b-btn
                      variant="success"
                      class="mr-1 mt-1"
                      @click="showModalFollow(data.item)"
                      >ویرایش</b-btn
                    >
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="
                  items.filter((x) => x.status == status.value).length
                "
                align="center"
                size="md"
                class="my-0"
              ></b-pagination>
            </b-card>
          </b-tab>
        </b-tabs>
      </div>

      <br />
    </b-card>
    <v-dialog v-model="groupChangeStatusDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر وضعیت گروهی محصولات</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-select
              v-model="selectedProgress"
              :items="progressOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="productNoteModal"
                 :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="groupChangeStatusDialog = false"
          >
            لغو
          </v-btn>
          <v-btn @click="submitProductsGroup()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editOrderItem" max-width="600px">
      <v-card>
        <v-card-title class="mb-3" style="padding-top: 38px">
          <h4>ویرایش {{ currentOrder.description }}</h4>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              outlined
              dense
              label="شرح کالا"
              v-model="currentOrder.description"
            />

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="currentOrder.material"
            />

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="currentOrder.coating"
            />

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="currentOrder.dimensionStandard"
            />

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="currentOrder.diameter"
            />

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="currentOrder.length"
            />

            <v-text-field
              outlined
              dense
              label="تعداد"
              v-model="currentOrder.number"
            />

            <v-select
              v-model="currentOrder.newStatus"
              :items="statusOptions"
              label="وضعیت جدید"
              class="mt-3"
              outlined
              dense
            ></v-select>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="currentOrder.orderItemNote"
                :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="editOrderItem = false">
            لغو
          </v-btn>
          <v-btn @click="editOrderItemId()" color="primary"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import router from "../../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      factory: new Object({
        code: "",
        dueDate: "",
      }),
      moment: moment,
      rejectReason: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      currentOrder: {},
      editOrderItem: false,

      items: [],
      filter: null,
      fields: [
        { key: "code", label: "کد سفارش" },
        { key: "customerName", label: "نام مشتری" },
        { key: "status", label: "وضعیت کالا" },
        { key: "description", label: "نام" },
        { key: "material", label: "متریال" },
        { key: "coating", label: "پوشش" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "diameter", label: "قطر" },
        { key: "length", label: "طول" },
        { key: "number", label: "واحد" },
        { key: "factoryStatus", label: "وضعیت سفارش" },
        { key: "priority", label: "اولویت تولید" },
        { key: "operation", label: "عملیات" },
      ],

      statusOptions: [
        { value: "بررسی اولیه", text: "بررسی اولیه" },
        { value: "توقف موقت تولید", text: "توقف موقت تولید" },
        {
          value: "در مرحله تامین مواد اولیه",
          text: "در مرحله تامین مواد اولیه",
        },
        { value: "در مرحله تولید", text: "در مرحله تولید" },
        { value: "در مرحله تامین", text: "در مرحله تامین" },
        { value: "موجود در انبار", text: "موجود در انبار" },
        { value: "در مرحله پوشش کاری", text: "در مرحله پوشش کاری" },
        { value: "اتمام تولید", text: "اتمام تولید" },
        { value: "در مرحله ارسال", text: "در مرحله ارسال" },
        { value: "در مرحله بسته بندی", text: "در مرحله بسته بندی" },
        { value: "لغو سفارش", text: "لغو سفارش" },
        { value: "تحویل نهایی", text: "تحویل نهایی" },
        { value: "خرید خدمت تولید", text: "خرید خدمت تولید" },
        {
          value: "خرید خدمت پوشش گالوانیزه گرم",
          text: "خرید خدمت پوشش گالوانیزه گرم",
        },
        { value: "خرید خدمت پوشش تفلون", text: "خرید خدمت پوشش تفلون" },
        { value: "خرید خدمت پوشش سرامیک", text: "خرید خدمت پوشش سرامیک" },
        { value: "خرید خدمت پوشش زایلون", text: "خرید خدمت پوشش زایلون" },
        {
          value: "خرید خدمت پوشش گالوانیزه سرد",
          text: "خرید خدمت پوشش گالوانیزه سرد",
        },
        { value: "خرید خدمت پوشش داک", text: "خرید خدمت پوشش داک" },
        { value: "خرید خدمت خدمات فورجینگ", text: "خرید خدمت خدمات فورجینگ" },
        { value: "خرید خدمت سختکاری", text: "خرید خدمت سختکاری" },
        { value: "در انتظار صدور نقشه فنی", text: "در انتظار صدور نقشه فنی" },
        {
          value: "در انتظار تایید نقشه فنی",
          text: "در انتظار تایید نقشه فنی",
        },
        { value: "در انتظار خرید خدمت", text: "در انتظار خرید خدمت" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      totalRows: "",
      striped: true,
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },

      role: "",
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    getTableInfo() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/orderItems/archive",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.items = res.data;
            this.totalRows = this.items.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.editOrderItem = true;
    },
    editOrderItemId() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/editOrderItemId",
        {
          orderItemId: this.currentOrder.id,
          status: this.currentOrder.newStatus,
          notes: this.currentOrder.orderItemNote,
          description: this.currentOrder.description,
          material: this.currentOrder.material,
          coating: this.currentOrder.coating,
          dimensionStandard: this.currentOrder.dimensionStandard,
          diameter: this.currentOrder.diameter,
          length: this.currentOrder.length,
          number: this.currentOrder.number,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.editOrderItem = false;
            this.getTableInfo();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    closeModalّFollow() {
      this.currentOrder = {};
      this.$refs["modalFollow"].hide();
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    updateOrder() {
      let baseId = this.currentOrder.totalOrder.custom_fields.filter(
        (x) => x.id == 158
      )[0].value;
      let currentId = this.currentOrder.taskId;
      Axios.put(
        this.baseUrl + "/issues/" + baseId + ".json",
        {
          issue: {
            uploads: [
              {
                token: this.mediaToken,
                filename: this.file.name,
                content_type: this.file.type,
              },
            ],
          },
        },
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      )
        .then(
          Axios.put(
            this.baseUrl + "/issues/" + currentId + ".json",
            {
              issue: {
                notes: this.content || "",
              },
            },
            {
              headers: {
                "X-Redmine-API-Key": window.localStorage.api_key,
              },
            }
          )
            .then(
              alert("پرونده با موفقیت به روز شد"),
              (this.content = ""),
              (this.file = ""),
              this.closeModalّFollow()
            )
            .catch((err2) => {
              console.log(err2);
            })
        )
        .catch((err) => {
          console.log(err);
        });
    },
    priceSent() {
      Axios.put(
        this.baseUrl + "/issues/" + this.currentOrder.taskId + ".json",
        {
          issue: {
            custom_fields: [
              {
                id: 159,
                value: this.sendMethod,
              },
              { id: 162, value: "در انتظار نظر مشتری" },
            ],
            uploads: [
              {
                token: this.mediaToken,
                filename: this.file.name,
                content_type: this.file.type,
              },
            ],
            notes: "پرونده برای مشتری ارسال شد. " + this.content || "",
          },
        },
        {
          headers: {
            "X-Redmine-API-Key": window.localStorage.api_key,
          },
        }
      )
        .then(
          alert("ارسال تعیین قیمت ثبت شد"),
          (this.content = ""),
          (this.file = ""),
          this.closeModalّFollowPrice(),
          this.getTableInfo()
        )
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    this.getTableInfo();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.progress {
  background-color: #222222 !important;
  padding-block-start: 20 px;
}
</style>
